// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fN","homeTitle_styleDefault":"c-a_fO","homeTitle_styleRed":"c-a_fP"};